















import { Component, Vue } from 'vue-property-decorator'
import { Activity } from '@/interfaces'
import { dateToString } from '@/utils'

@Component
export default class ActivityList extends Vue {
  get activities (): Activity[] {
    return this.$store.getters['activities/recent']
  }

  formatDate (date: number) {
    return dateToString(date)
  }

  onActivitySelected (activity: Activity) {
    this.$emit('select', activity)
  }
}
